export const CashflowTitles = {
  CashflowStatement: "Cashflow Statement",
  OpeningBalance: "Opening Balance",
  CashIn: "Total Cash In",
  CashOut: "Total Cash Out",
  NetCashflow: "Net Cashflow",
  Unreconciled: "Unreconciled",
  ClosingBalance: "Closing Balance",
};
